import axiosInstance from "../mainService";

const milestoneService = {
    getMilestones(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m140_milestones/description/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllMilestones(search, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m140_milestones/description/${sanitizedSearch}/${company_id}`);
    },
    deleteMilestone(id) {
        return axiosInstance.delete(`/delete-data/m140_milestones/${id}`);
    },
    updateMilestone(data) {
        return axiosInstance.put(`/update-data/m140_milestones/${data.id}`, data);
    },
    addMilestone(data) {
        return axiosInstance.post('/insert-data/m140_milestones', data);
    }
};

export default milestoneService;